import { QUESTION, TRO_PAGE_RECORDING } from './timeTrackingKeys';

export const TIME_TRACKING_STOP = 'TIME_TRACKING_STOP';
export const TIME_TRACKING_START = 'TIME_TRACKING_START';
export const RESET_TIME_TRACKING_STATE = 'RESET_TIME_TRACKING_STATE';
export const TIME_TRACKING_ADD_TO_START_TIME = 'TIME_TRACKING_ADD_TO_START_TIME';
export const SAVE_READING_TIME_TRACKING_DATA = 'SAVE_READING_TIME_TRACKING_DATA';

export const startTimeTracking = timerKey => ({
    timerKey,
    type: TIME_TRACKING_START,
    timestamp: Date.now(),
});

export const stopTimeTracking = timerKey => ({
    timerKey,
    type: TIME_TRACKING_STOP,
    timestamp: Date.now(),
});
export const saveTimeTrackingData = timerKey => ({
    timerKey,
    type: SAVE_READING_TIME_TRACKING_DATA,
    timestamp: Date.now(),
});

export const startQuestionTimeTracking = () => ({
    timerKey: QUESTION,
    type: TIME_TRACKING_START,
    timestamp: Date.now(),
});

export const stopQuestionTimeTracking = () => ({
    timerKey: QUESTION,
    type: TIME_TRACKING_STOP,
    timestamp: Date.now(),
});

export const resetTimeTrackingState = timerKey => ({
    timerKey,
    type: RESET_TIME_TRACKING_STATE,
});

export const resetQuestionTimeTracking = () => resetTimeTrackingState(QUESTION);

export const resetPageRecordingTimeTracking = () => resetTimeTrackingState(TRO_PAGE_RECORDING);

/**
 * Add some time in milliseconds to the response start timestamp, useful
 * in cases such as excluding a time period, where the user is not interacting
 * with the page, from the total response time .
 */
export const addToStartTime = (timerKey, milliseconds) => ({
    timerKey,
    type: TIME_TRACKING_ADD_TO_START_TIME,
    milliseconds,
});
